import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id DD1AC44D-81B8-42EF-8714-7E7D29F2BC3F
 * name arrow-top-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left.svg
 * tags
 * - Arrow 
 */
export const ArrowTopLeftIcon = createSvgIcon(<><path d="M19,17.59L17.59,19L7,8.41V15H5V5H15V7H8.41L19,17.59Z" /></>, 'ArrowTopLeftIcon');
export default ArrowTopLeftIcon